import {Alert, Chip, Stack, TextField, Typography} from "@mui/material";
import {useCategoriasFolha} from "../../api/DpgeIntegracaoEsfingeApi";
import {
    CATEGORIAS_FOLHA,
    CATEGORIAS_COMPLEMENTARES
} from "../../shared/categoriasFolha";

export function referenciasParaPreparacao(referencias = {}) {
    return Object.fromEntries(
        Object.entries(referencias)
            .filter(([, valor]) => valor)
            .map(([categoria, valor]) => [
                categoria,
                Number(valor.replace("-", ""))
            ])
    );
}

export default function CategoriasDisponiveis({
    anoMes,
    referencias = {},
    onChange
}) {
    const {data = [], isLoading, error} = useCategoriasFolha(anoMes);
    if (isLoading)
        return <Typography>Consultando folhas disponíveis…</Typography>;
    if (error)
        return (
            <Alert severity="error">
                Não foi possível consultar as categorias disponíveis. A
                preparação fará nova consulta à origem.
            </Alert>
        );
    const complementares = data.filter((categoria) =>
        CATEGORIAS_COMPLEMENTARES.includes(categoria)
    );
    return (
        <Stack spacing={2}>
            <Typography variant="subtitle2">Disponíveis na origem</Typography>
            <Stack direction="row" flexWrap="wrap" sx={{gap: 1}}>
                {data.map((categoria) => (
                    <Chip
                        key={categoria}
                        size="small"
                        label={CATEGORIAS_FOLHA[categoria] || categoria}
                    />
                ))}
                {!data.length && (
                    <Typography variant="body2">
                        Nenhuma categoria encontrada.
                    </Typography>
                )}
            </Stack>
            {complementares.length > 0 && (
                <Alert severity="info">
                    Informe a competência à qual cada complementar se refere. A
                    mesma competência gera uma folha adicional; uma anterior
                    gera suplementar. Sem essa informação, a folha aparecerá
                    bloqueada para envio. Se houver referências diferentes na
                    mesma categoria, separe os dados na origem.
                </Alert>
            )}
            {complementares.map((categoria) => (
                <TextField
                    key={categoria}
                    type="month"
                    fullWidth
                    label={
                        "Competência de referência — " +
                        CATEGORIAS_FOLHA[categoria]
                    }
                    InputLabelProps={{shrink: true}}
                    inputProps={{
                        max: anoMes.slice(0, 4) + "-" + anoMes.slice(4)
                    }}
                    value={referencias[categoria] || ""}
                    onChange={(event) =>
                        onChange({
                            ...referencias,
                            [categoria]: event.target.value
                        })
                    }
                    helperText="Confirme a referência nos documentos da folha; ela não é presumida pelo conector."
                />
            ))}
        </Stack>
    );
}
